import { Suspense, useMemo } from 'react';
import { useRoutes, Outlet } from 'react-router-dom';

import {
  AuthMiddleware,
  PrivateRoutesMiddleware,
  AccountStatusGuard,
} from './middlewares';

import { useUserInfo } from '@/hooks';
import { EnvFlag, Layout, Login, Register, ForgotPassword } from '@/pages';
import { LoaderBackdrop } from '@/components';
import { publicRoutes } from './PublicRoutes';

const SuspenseWrapper = () => (
  <Suspense fallback={<LoaderBackdrop />}>
    <Outlet />
  </Suspense>
);

export const Router = () => {
  const { permissions } = useUserInfo();

  const privateRoutes = useMemo(
    () => PrivateRoutesMiddleware({ permissions }),
    [permissions]
  );

  return useRoutes([
    {
      element: <SuspenseWrapper />,
      children: [
        {
          element: <EnvFlag />,
          children: [
            ...publicRoutes,
            {
              path: '/register/:userId',
              element: <Register />,
            },
            {
              path: '/forgot-password',
              element: <ForgotPassword />,
            },
            {
              element: <AuthMiddleware />,
              children: [
                {
                  path: '/login',
                  element: <Login />,
                },
                {
                  element: <AccountStatusGuard />,
                  children: [
                    {
                      element: <Layout />,
                      children: [...privateRoutes],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ]);
};
